import { Injectable, inject } from '@angular/core';

import { Token } from 'src/app/auth/models/token.model';
import { AccessEventsService } from 'src/app/auth/services/access-events.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  accessEvents = inject(AccessEventsService);

  private TOKEN_KEY = `columbus_${environment.name}_desktop_token`;
  private TOKEN_EXPIRATION_KEY = `columbus__${environment.name}_desktop_token_expiration`;
  private REFRESH_TOKEN_KEY = `columbus__${environment.name}_desktop_refresh_token`;
  private REFRESH_TOKEN_EXPIRATION_KEY = `columbus__${environment.name}_desktop_refresh_token_expiration`;
  private LANGUAGE_KEY = `columbus__${environment.name}_desktop_language`;

  constructor() {
    this.accessEvents.onAccess.subscribe((accessType) => {
      if (accessType === 'logout') {
        this.removeAllAuthTokens();
      }
    });
  }

  get token(): Token | null {
    const key = localStorage.getItem(this.TOKEN_KEY);
    const expiration = localStorage.getItem(this.TOKEN_EXPIRATION_KEY);
    const refreshToken = localStorage.getItem(this.REFRESH_TOKEN_KEY);
    const refreshTokenExpires = localStorage.getItem(this.REFRESH_TOKEN_EXPIRATION_KEY);
    return !key || !expiration || !refreshToken || !refreshTokenExpires
      ? null
      : { key, expiration, refreshToken, refreshTokenExpires };
  }

  set token(token: Token | null) {
    if (token) {
      localStorage.setItem(this.TOKEN_KEY, token.key);
      localStorage.setItem(this.TOKEN_EXPIRATION_KEY, token.expiration);
      localStorage.setItem(this.REFRESH_TOKEN_KEY, token.refreshToken);
      localStorage.setItem(this.REFRESH_TOKEN_EXPIRATION_KEY, token.refreshTokenExpires);
    }
  }

  removeAllAuthTokens() {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.TOKEN_EXPIRATION_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_EXPIRATION_KEY);
  }

  get language(): string {
    return localStorage.getItem(this.LANGUAGE_KEY) as string;
  }

  set language(language: string) {
    localStorage.setItem(this.LANGUAGE_KEY, language);
  }

  removeLanguage() {
    localStorage.removeItem(this.LANGUAGE_KEY);
  }
}
